import React from "react";
import { Chart } from "primereact/chart";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";

const DashboardAnalyticsClient = ({ data }) => {
  const clientMap = new Map();
  const currentDate = new Date();
  const currentPeriodStr = `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, "0")}`;
  const latestPeriod = data.find((d) => d.mes === currentPeriodStr) || data[0];

  (latestPeriod?.asignacionesPeriodo || []).forEach((asig) => {
    const id = asig.idCotizacion;
    const nombre = asig.cliente?.nombreFantasia || "Sin nombre";
    const total = asig.totalPfUf || 0;
    if (clientMap.has(id)) {
      const client = clientMap.get(id);
      client.totalPfUf += total;
    } else {
      clientMap.set(id, { idCotizacion: id, nombreFantasia: nombre, totalPfUf: total });
    }
  });
  const clientSummary = Array.from(clientMap.values());

  const clientChartData = {
    labels: clientSummary.map((c) => c.nombreFantasia),
    datasets: [
      {
        label: "Total UF",
        data: clientSummary.map((c) => c.totalPfUf),
        backgroundColor: "#42A5F5",
      },
    ],
  };
  const baseHeight = Math.max(300, clientSummary.length * 35);
  const tableHeight = baseHeight + "px";
  const chartHeight = baseHeight;
  const chartOptions = {
    indexAxis: "y",
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      tooltip: {
        callbacks: {
          label: function(context) {
            let label = context.dataset.label || '';
            if (label) {
              label += ': ';
            }
            if (context.parsed.x !== undefined) {
              label += 'UF ' + context.parsed.x.toFixed(2);
            }
            return label;
          }
        }
      }
    },
    scales: {
      x: {
        beginAtZero: true,
        ticks: {
          color: "#495057",
          callback: function(value) {
            return 'UF ' + value;
          }
        },
        grid: { color: "#ebedef" },
      },
      y: {
        ticks: { color: "#495057", autoSkip: false },
        grid: { color: "#ebedef" },
      },
    },
  };
  
  const getMonthName = (mes) => {
    const [year, month] = mes.split("-");
    return new Date(year, month - 1).toLocaleString("default", { month: "long" }) + " " + year;
  };
  const periodRangeLabel = getMonthName(latestPeriod?.mes || "");

  return (
    <div className="grid dashboard" style={{ alignItems: "stretch" }}>

      <div
        className="col-12 md:col-6"
        style={{ display: "flex", flexDirection: "column", height: "100%" }}
      >
        <div className="card" style={{ flex: 1, display: "flex", flexDirection: "column", height: "100%" }}>
          <h5>Cierre de Clientes ({periodRangeLabel})</h5>
          <DataTable
            value={clientSummary}
            className="p-datatable-sm"
            scrollable
            scrollHeight={tableHeight}
            stripedRows
            showGridlines
          >
            <Column field="idCotizacion" header="Asignación" sortable />

            <Column field="nombreFantasia" header="Nombre Fantasía" sortable />

            <Column
              field="totalPfUf"
              header="Total"
              body={(row) => `UF ${row.totalPfUf.toFixed(2)}`}
              sortable
            />
          </DataTable>
          <div style={{ marginTop: "10px", fontWeight: "bold" }}>
            Total General: UF {clientSummary.reduce((acc, curr) => acc + curr.totalPfUf, 0).toFixed(2)}
          </div>
        </div>
      </div>
      <div
        className="col-12 md:col-6"
        style={{ display: "flex", flexDirection: "column", height: "100%" }}
      >
        <div className="card" style={{ flex: 1, display: "flex", flexDirection: "column" }}>
          <h5>Comparación por Cliente</h5>
          <Chart
            type="bar"
            data={clientChartData}
            options={chartOptions}
            height={chartHeight}
          />
        </div>
      </div>

      
    </div>
  );
};

export default React.memo(DashboardAnalyticsClient);
